import React from "react";
import { Modal, Box, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Eye, Trash2, ArrowLeft } from "lucide-react";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(300px, 90vw)",
  bgcolor: "#fff",
  borderRadius: "18px",
  boxShadow: "0 16px 40px rgba(0, 0, 0, 0.16)",
  p: 2,
};

export default function ModalOpcoesEnfermeiro({ open, onClose, onVisualizar, onExcluir }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <List disablePadding>
          <ListItemButton sx={{ borderRadius: 2, mb: 0.5 }} onClick={onVisualizar}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <Eye size={18} />
            </ListItemIcon>
            <ListItemText
              primary="Visualizar"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>
          <ListItemButton sx={{ borderRadius: 2, mb: 0.5 }} onClick={onExcluir}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <Trash2 size={18} />
            </ListItemIcon>
            <ListItemText
              primary="Excluir"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>
          <ListItemButton sx={{ borderRadius: 2, mt: 1 }} onClick={onClose}>
            <ListItemIcon sx={{ minWidth: 36, color: "#0037FF" }}>
              <ArrowLeft size={18} />
            </ListItemIcon>
            <ListItemText
              primary="Voltar"
              primaryTypographyProps={{ color: "#0037FF", fontWeight: 500 }}
            />
          </ListItemButton>
        </List>
      </Box>
    </Modal>
  );
}
